import { useEffect } from 'react';

type EventHandler = (e: KeyboardEvent) => void;

export default (fn?: EventHandler) => {
    useEffect(() => {
        window.addEventListener('keydown', fn as EventListener);

        return () => window.removeEventListener('keydown', fn as EventListener);
    }, [fn]);
};
